export default {
  name: 'notification',
  components: {},
  props: [],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    notifications () {
      return this.$store.getters['Notification/getNotification']
    },
    last_page () {
      return this.$store.getters['Notification/getLastPage']
    },
    current_page () {
      return this.$store.getters['Notification/getCurrentPage']
    }
  },
  mounted () {
  },
  created () {
    window.addEventListener('scroll', this.scrollFunction)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollFunction)
  },
  methods: {
    readNotification (notification) {
      this.$router.push(notification.link)
      if (!notification.read_at) {
        this.$store.dispatch('Notification/readNotification', notification)
      }
    },
    scrollFunction () {
      let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight
      if (bottomOfWindow && this.last_page > this.current_page) {
        this.loading = true
        Promise.all([
          this.$store.dispatch('Notification/getNotification', {page: ++this.current_page})
        ]).then(res => {
          this.loading = false
        }).catch(errors => {
          this.loading = false
          console.log(errors)
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/notification/notification.js